import cx from "classnames";
import React from "react";
import { connect } from "react-redux";

import {
    sellExperiencePopupClose,
    sellExperiencePopupWrite,
} from "@/mk2/apps/bazaar/containers/SellExperiencePopup/SellExperiencePopup.actions";
import { getSellExperiencePopupState } from "@/mk2/apps/bazaar/containers/SellExperiencePopup/SellExperiencePopup.selectors";
import { wikiAddExperienceToUndefinedArticleUrl } from "@/mk2/apps/wiki/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Modal } from "@/mk2/components/Modal";
import { Panel } from "@/mk2/components/Panel";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { url } from "@/mk2/helpers/urls";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import { AppState } from "@/mk2/reducers";
import {
    BZ2_SELL_EXP_POPUP_BUTTON_LATER,
    BZ2_SELL_EXP_POPUP_BUTTON_WRITE,
    BZ2_SELL_EXP_POPUP_TEXT,
    BZ2_SELL_EXP_POPUP_TITLE,
} from "@/mk/autogenerated/translations/SellExperiencePopup.2a27249e07e136ea1abad3b80c84760b";

import styles from "./SellExperiencePopup.mscss";

interface OwnProps {
    className?: string;
}

interface StateProps {
    show: boolean;
    productId: number;
    title: string;
}

interface DispatchProps {
    onWrite(productId: number);
    onClose(productId: number);
}

type Props = OwnProps & StateProps & DispatchProps;

const SellExperiencePopup: React.FunctionComponent<Props> = ({
    className,
    show,
    productId,
    title,
    onWrite,
    onClose,
}) => {
    const onWriteCallback = useEventCallback(() => {
        onWrite(productId);
    }, [productId]);

    const onCloseCallback = useEventCallback(() => {
        onClose(productId);
    }, [productId]);

    const writeUrl = url(
        wikiAddExperienceToUndefinedArticleUrl,
        {},
        {
            fromProduct: productId,
            ...(title ? { articleProposal: title } : {}),
        },
    );

    return (
        <Modal show={show} className={cx(styles.SellExperiencePopup, className)} backdrop="static">
            <Panel className={styles.SellExperiencePopup__container}>
                <h1 className={styles.SellExperiencePopup__title}>{BZ2_SELL_EXP_POPUP_TITLE}</h1>
                <div className={styles.SellExperiencePopup__text}>{BZ2_SELL_EXP_POPUP_TEXT}</div>
                <div className={styles.SellExperiencePopup__buttons}>
                    <Btn
                        className={styles.SellExperiencePopup__buttons__button}
                        type={BtnType.Blue}
                        label={BZ2_SELL_EXP_POPUP_BUTTON_WRITE}
                        link={writeUrl}
                        onClick={onWriteCallback}
                    />{" "}
                    <Btn
                        className={styles.SellExperiencePopup__buttons__button}
                        type={BtnType.BlueOutline}
                        label={BZ2_SELL_EXP_POPUP_BUTTON_LATER}
                        onClick={onCloseCallback}
                    />
                </div>
            </Panel>
        </Modal>
    );
};

SellExperiencePopup.displayName = "SellExperiencePopup";

export { SellExperiencePopup };

function mapStateToProps(state: AppState): StateProps {
    const substate = getSellExperiencePopupState(state);

    return {
        show: substate.show,
        productId: substate.productId,
        title: substate.title,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onWrite: sellExperiencePopupWrite,
    onClose: sellExperiencePopupClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(SellExperiencePopup);
